import React, { memo } from 'react';
import cls from './WeeksModeCharter.module.css';
import classNames from 'classnames';
import { WeeksModePosition } from '../WeeksModePosition/WeeksModePosition';
import { useSelector } from 'react-redux';
import { positionSelector } from '../../../../../../../store/reducers/positionSlice/positionSlice';

import { WeekItemCharter } from './WeekItemCharter';

export const WeeksModeCharter = memo(({ charter }) => {
    const { weeks, opensCharters } = useSelector((state) => state.gantReducer);

    const positions = useSelector(positionSelector.selectEntities);
    const { settings } = useSelector((state) => state.gantReducer);
    const isLabor = charter?.children.some((guid) => positions[guid].type === 'labor');
    const isShowPosition = isLabor || settings.isShowMHD;
    if (!charter || !isShowPosition) {
        return null;
    }

    let isPlanFactShow = true;

    if (isPlanFact) {
        isPlanFactShow = isPlanFact && !!charter.planned.start_date;
    }

    if (!isPlanFactShow) {
        return null;
    }
    return (
        <div className={classNames(cls.DaysModeCharter)}>
            <div className={classNames(cls.weeks)}>
                {weeks.map((week) => (
                    <div className={classNames(cls.weeks)} key={Math.random().toString(36)}>
                        {week.weeks.map((item) => (
                            <WeekItemCharter
                                charter={charter}
                                week={item}
                                isPlanFact={isPlanFact}
                                key={Math.random().toString(36)}
                            />
                        ))}
                    </div>
                ))}
            </div>
            {opensCharters[charter.guid] && (
                <>
                    {charter.children.map((positionGuid) => (
                        <WeeksModePosition
                            key={positionGuid + Math.random().toString(36)}
                            position={positions[positionGuid]}
                        />
                    ))}
                </>
            )}
        </div>
    );
});
